import { SCREENS } from 'src/constants/screens';
import { USER_ROLES } from 'src/constants/user';
import { IScreenTab } from 'src/view/containers/ScreenTabsNavigation/ScreenTabsNavigation';

export const itemManagementNavigation = (itemId: number, modifierId: number): IScreenTab[] => {
  let mainDetailsPath = SCREENS.ITEMS_CREATE();
  let disabled = true;

  if (itemId > 0) {
    mainDetailsPath = SCREENS.ITEMS_EDIT(itemId);
    disabled = false;
  }

  const screens = [
    { path: mainDetailsPath, title: 'main_details', accessRoles: [USER_ROLES.RESTAURANT_MANAGER] },
    {
      path: SCREENS.ITEMS_BRANCHES_CONFIGURATION(itemId),
      title: 'branch_configuration',
      accessRoles: [USER_ROLES.RESTAURANT_MANAGER],
      disabled,
    },
    {
      path: SCREENS.ITEMS_BRANCHES_MODIFIERS(itemId),
      title: 'branch_modifiers',
      accessRoles: [USER_ROLES.RESTAURANT_MANAGER],
      disabled: disabled || modifierId === 0,
      visible: modifierId > 0,
    },
  ];

  return screens;
};
